import { boxAdd, boxAddItem, boxDelItem, BoxDoType, boxEdit, boxEditItem, boxShipStatus as boxShipStatusApi, orderFetch, orderSourceItems, orderUpdate, packBoxOpt, PackDoType, packLogistcs, packOrderOpt } from "@/apis/packing";
import { OrderItemV2, OrderV2 } from "@/types/inventoryV2";
import { orderFetch as fetchInventory } from "@/apis/inventoryv2";
import { AddPackBox, AddPackBoxItem, BoxShipStatus, BoxStatus, PackOrder, PackOrderAdd, PackOrderStatus, PackSourceItem } from "@/types/packing";
import { notification } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Logistics, Shipment } from "@/types/shipment";
import { SaleItemState, SaleOrderItemState } from "@/types/sales";
import { fetchsWithOrg } from "@/apis/order";
import { orderList } from "@/apis/shipment";
import { PurchaseOrderItem } from "@/types/purchase";

type LoadingType = "PackOrder"
  | "PackOrderDel"
  | "PackOrderSeal"
  | "PackOrderConfirm"
  | "PackOrderUpdate"
  | "BoxSeal"
  | "BoxUnSeal"
  | "BoxAdd"
  | "BoxEdit"
  | "BoxDel"
  | "ItemAdd"
  | "ItemDel"
  | "ItemEdit";

// 排序盒子
const sortPackingBoxes = (boxes: PackOrder["boxes"]) => (
  [...(boxes || [])]
    .sort((a, b) => a.createdAt - b.createdAt)
);

const usePackOrderDetail = (detail?: PackOrder) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<LoadingType | undefined>(undefined);
  const [orderData, setOrderData] = useState<PackOrder | null>(detail ?? null);
  const [sourceInventory, setSourceInventory] = useState<OrderV2 | null>(null);
  const [logistcsOrders, setLogistcsOrders] = useState<Logistics[]>([]);
  const [shipments, setShipments] = useState<Shipment[]>([]);
  const [sourceItems, setSourceItems] = useState<PackSourceItem[]>([]);
  const [boxShipStatus, setBoxShipStatus] = useState<BoxShipStatus[]>([]);
  const [saleItems, setSaleItems] = useState<SaleItemState[]>([]);
  const [inventoryOrders, setInventoryOrders] = useState<OrderV2[]>([]);

  const fetchData = async (orderId?: string) => {
    let id = orderId ?? detail?.id ?? '';
    if (!!!id || loading) return;
    try {
      setLoading("PackOrder");
      let order = await orderFetch(id);
      let sItems = await orderSourceItems(id);
      let logistcs = await packLogistcs(id);
      !!logistcs && setLogistcsOrders([...logistcs]);
      setOrderData({
        ...order,
        boxes: sortPackingBoxes(order.boxes),
      });
      setSourceItems([...sItems])
      let sourceId = order.sourceOrderId;
      if (sourceId && order.status === PackOrderStatus.DRAFT) {
        let inventory = await fetchInventory(sourceId);
        setSourceInventory({ ...inventory })
      }

      let status = await boxShipStatusApi(order.id);
      setBoxShipStatus(status || []);

      let ids: string[] = [];
      (status || []).forEach(s => {
        if (!!s.shipmentOrderId) ids.push(s.shipmentOrderId)
      });
      if (ids.length > 0) {
        let shipmentOrders = await orderList({ strs: ids });
        setShipments([...(shipmentOrders.body ?? [])]);
      };
      
      let saleIds: string[] = [];
      let orderIds: string[] = [];
      let outInvOrders: OrderV2[] = [];
      (order.inventoryOrders ?? []).forEach(inv => {
        if (inv.sourceId) saleIds.push(inv.sourceId);
        orderIds.push(inv.id);
      });
      if (saleIds.length > 0) {
        let sales = await fetchsWithOrg({ strs: saleIds });
        if (!!sales.body) {
          let items: SaleItemState[] = [];
          sales.body.forEach(sale => {
            if (sale.items) {
              items.push(...sale.items.map(si => ({
                ...si,
                order: {
                  ...sale,
                  items: []
                }
              })))
            }
          });
          setSaleItems(items)
        }
      };
      if (orderIds.length > 0) {
        for (let ooi = 0; ooi < orderIds.length; ooi++) {
          try {
            let outInvOrder = await fetchInventory(orderIds[ooi]);
            !!outInvOrder && outInvOrders.push(outInvOrder);
          } catch (error) { }
        }
      }
      setInventoryOrders([...outInvOrders]);
      return order
    } catch (error) {
      notification.error({ message: t('counting.loadFailed') })
    } finally {
      setLoading(undefined);
    }
  };

  const doOrder = async (type: PackDoType, orderId?: string, notip?: boolean) => {
    let id = orderId ?? orderData?.id ?? '';
    if (!!!id || loading) return;
    let status: PackOrderStatus = type === "confirm" ? PackOrderStatus.CONFIRMED : type === "seal-all" ? PackOrderStatus.SHUTED : PackOrderStatus.WASTED
    try {
      setLoading(type === "confirm" ? "PackOrderConfirm" : type === "seal-all" ? "PackOrderSeal" : "PackOrderDel");
      await packOrderOpt(id, type);
      setOrderData(last => last ? ({
        ...last,
        boxes: (last.boxes || []).map(box => ({ ...box, status: type === "seal-all" ? BoxStatus.SHUTED : box.status })),
        status
      }) : null);
      !notip && notification.success({ message: t(type === "confirm" ? 'warehouse.confirmSucc' : type === "seal-all" ? 'warehouse.sealSucc' : 'warehouse.wasted') });
      setLoading(undefined)
    } catch (error: any) {
      !notip && notification.error({ message: t(type === "confirm" ? 'warehouse.confirmFail' : type === "seal-all" ? 'warehouse.sealFail' : 'warehouse.wasteFail'), description: error === 74011 ? t('warehouse.noBox') : undefined });
      setLoading(undefined);
      throw error
    }
  };

  const updateOrder = async (data: PackOrderAdd, orderId?: string) => {
    let id = orderId ?? orderData?.id ?? '';
    if (!!!id || loading) return;
    try {
      setLoading("PackOrderUpdate");
      let newOrder = await orderUpdate(id, data);
      orderData && setOrderData({
        ...orderData,
        remark: newOrder.remark
      })
      notification.success({ message: t('common.saveOk') })
      return newOrder;
    } catch (error) {
      notification.error({ message: t('common.saveFAil') })
    } finally {
      setLoading(undefined)
    }
  };


  const doBox = async (type: BoxDoType, boxId: string, notip?: boolean) => {
    if (!!!boxId || loading) return false;
    try {
      setLoading(type === "remove" ? "BoxDel" : type === "seal" ? "BoxSeal" : "BoxUnSeal");
      await packBoxOpt(boxId, type);
      setLoading(undefined);
      !notip && notification.success({ message: t(type === "seal" ? 'warehouse.sealSucc' : type === "unseal" ? 'warehouse.unSealSucc' : 'common.deleteSuccess') });
      return true;
    } catch (error) {
      !notip && notification.error({ message: t(type === "seal" ? 'warehouse.sealFail' : type === "unseal" ? 'warehouse.unSealFail' : 'common.deleteFail') });
      setLoading(undefined);
      return false;
    }
  };

  const addBox = async (data: AddPackBox, orderId?: string, notip?: boolean) => {
    let id = orderId ?? orderData?.id ?? '';
    if (!!!id || loading) return;
    try {
      setLoading("BoxAdd");
      let newBox = await boxAdd(id, data);
      if (orderData) {
        let boxes = [...(orderData.boxes || [])];
        boxes.push({ ...newBox })
        setOrderData({
          ...orderData,
          boxes,
        })
      };
      !notip && notification.success({ message: t('common.addSuccess') });
      return newBox;
    } catch (error) {
      !notip && notification.error({ message: t('common.addError') })
    } finally {
      setLoading(undefined)
    }
  };

  const editBox = async (data: Partial<AddPackBox>, boxId: string, notip?: boolean) => {
    if (loading) return;
    try {
      setLoading("BoxEdit");
      let newBox = await boxEdit(boxId, data);
      if (orderData) {
        let boxes = [...(orderData.boxes || [])].map(b => b.id === boxId ? ({ ...newBox }) : ({ ...b }));
        setOrderData({
          ...orderData,
          boxes,
        })
      };
      !notip && notification.success({ message: t('common.saveOk') });
      setLoading(undefined);
      return newBox;
    } catch (error) {
      !notip && notification.error({ message: t('common.saveFAil') });
      setLoading(undefined);
      return false;
    }
  };

  const addItem = async (boxId: string, data: AddPackBoxItem, notip?: boolean) => {
    if (loading) return;
    try {
      setLoading("ItemAdd");
      let newItem = await boxAddItem(boxId, data);
      if (orderData) {
        let boxes = [...(orderData.boxes || [])].map(b => {
          if (b.id === boxId) {
            let items = [...(b.items || [])];
            items.push({ ...newItem });
            return { ...b, items };
          }
          return { ...b };
        });
        setOrderData({
          ...orderData,
          boxes,
        })
      };
      !notip && notification.success({ message: t('common.addSuccess') });
      return newItem;
    } catch (error) {
      !notip && notification.error({ message: t('common.addError') })
    } finally {
      setLoading(undefined)
    }
  };

  const editItem = async (itemId: string, data: AddPackBoxItem, notip?: boolean) => {
    if (loading) return;
    try {
      setLoading("ItemEdit");
      let newItem = await boxEditItem(itemId, data);
      if (orderData) {
        let boxes = [...(orderData.boxes || [])].map(b => {
          let items = [...(b.items || [])];
          let idx = items.findIndex(i => i.id === itemId);
          if (idx >= 0) {
            items[idx] = { ...newItem };
            return { ...b, items };
          }
          return { ...b };
        });
        setOrderData({
          ...orderData,
          boxes,
        })
      };
      !notip && notification.success({ message: t('common.saveOk') });
      return newItem;
    } catch (error) {
      !notip && notification.error({ message: t('common.saveFAil') })
    } finally {
      setLoading(undefined)
    }
  };


  const delItem = async (itemId: string) => {
    if (loading) return;
    try {
      setLoading("ItemDel");
      let newItem = await boxDelItem(itemId);
      if (orderData) {
        let boxes = [...(orderData.boxes || [])].map(b => {
          let items = (b.items || []).filter(i => i.id !== itemId);
          return {
            ...b,
            items
          }
        });
        setOrderData({
          ...orderData,
          boxes,
        })
      };
      notification.success({ message: t('common.rmSuccess') });
      return newItem;
    } catch (error) {
      notification.error({ message: t('common.rmError') })
    } finally {
      setLoading(undefined)
    }
  };

  const addShipment = (shipment: Shipment) => {
    setShipments(last => ([...last, shipment]))
  };

  const addLogistics = (logis: Logistics) => {
    setLogistcsOrders(last => ([...last, logis]))
  };

  return {
    loading,
    orderData,
    sourceItems,
    sourceInventory,
    logistcsOrders,
    shipments,
    boxShipStatus,
    saleItems,
    inventoryOrders,
    setOrderData,
    setSourceItems,
    fetchData,
    doOrder,
    updateOrder,
    doBox,
    addBox,
    editBox,
    addItem,
    editItem,
    delItem,
    setBoxShipStatus,
    addShipment,
    addLogistics,
    setInventoryOrders,
  };
};

export default usePackOrderDetail;
